export default "__VITE_ASSET__bbcd59d6__"